import { UserAccountRoles, UserDto } from '@/lib/users/dto/user.dto';

export function getFullName(user?: { firstName?: string; lastName?: string }) {
  const { firstName, lastName } = user ?? {};

  if (!firstName && !lastName) {
    return '';
  }

  if (!lastName) {
    return firstName ?? '';
  }

  return `${firstName ? `${firstName} ` : ''}${lastName}`;
}

export function getHasMembership(user?: UserDto) {
  return (
    user != null &&
    user.accounts.some(
      (account) =>
        account.roles.includes(UserAccountRoles.Member) ||
        account.roles.includes(UserAccountRoles.DecisionMaker) ||
        account.roles.includes(UserAccountRoles.Billing)
    )
  );
}

export function getHasDecisionMakerRole(user?: UserDto) {
  return (
    user != null &&
    user.accounts.some((account) =>
      account.roles.includes(UserAccountRoles.DecisionMaker)
    )
  );
}

export function canBuyOfficeAt(user?: UserDto, locationId?: string) {
  const userHasMembership = getHasMembership(user);
  const isUserADecisionMaker = getHasDecisionMakerRole(user);
  const isOfficeLocationPrimaryLocation =
    locationId === user?.primaryAccountLocationId;

  return (
    !userHasMembership ||
    isUserADecisionMaker ||
    !isOfficeLocationPrimaryLocation
  );
}

export function isUserIndustriousEmployee(email: string) {
  return email.endsWith('@industriousoffice.com');
}
